const content = `
<p>
  <strong style="color: rgb(20, 21, 26);">
    <u>
      重要须知：
    </u>
  </strong>
  <span style="color: rgb(20, 21, 26);">
    包小鉴App/字节跳动小程序/包小鉴H5一贯重视用户的个人信息及个人隐私的保护，在您使用包小鉴App/字节跳动小程序/包小鉴H5的服务和/或在包小鉴App/字节跳动小程序/包小鉴H5购物的时候，平台有可能会收集和使用您的个人信息及隐私。
  </span>
  <strong style="color: rgb(20, 21, 26);">
    <u>
      为此，包小鉴App/字节跳动小程序/包小鉴H5通过本《隐私权政策》向您说明您在使用包小鉴App/字节跳动小程序/包小鉴H5的服务和/或在包小鉴App/字节跳动小程序/包小鉴H5购物时，平台是如何收集、保存、使用和分享这些信息的，以及平台向您提供的访问、更新、控制和保护这些信息的方式。
    </u>
  </strong>
</p>
<p>
  <br>
</p>
<p>
  <strong style="color: rgb(20, 21, 26);">
    <u>
      本《隐私权政策》与您使用平台的服务、在平台购物息息相关，请您务必仔细阅读、充分理解（未成年人应当在其监护人的陪同下阅读）
    </u>
  </strong>
  <span style="color: rgb(20, 21, 26);">
    。
  </span>
</p>
<p>
  <br>
</p>
<p>
  <strong style="color: rgb(20, 21, 26);">
    <u>
      在使用包小鉴App/字节跳动小程序/包小鉴H5各项产品或服务前，请您务必仔细阅读本政策，特别是以粗体下划线标识的条款，您应重点阅读，在确认充分理解并同意后再开始使用。
    </u>
  </strong>
  <span style="color: rgb(20, 21, 26);">
    如对本政策内容有任何疑问、意见或建议，您可通过平台提供的各种联系方式与我们取得联系。
  </span>
</p>
<p>
  <br>
</p>
<p>
  <span style="color: rgb(20, 21, 26);">
    本隐私权政策将帮助您了解以下内容：
  </span>
</p>
<p>
  <span style="color: rgb(20, 21, 26);">
    1、个人隐私信息定义及保证
  </span>
</p>
<p>
  <span style="color: rgb(20, 21, 26);">
    2、我们如何收集和使用您的个人信息
  </span>
</p>
<p>
  <span style="color: rgb(20, 21, 26);">
    3、我们如何管理及保护您的个人信息
  </span>
</p>
<p>
  <span style="color: rgb(20, 21, 26);">
    4、我们如何共享、转让、公开披露您的信息
  </span>
</p>
<p>
  <span style="color: rgb(20, 21, 26);">
    5、我们如何处理未成年人的信息
  </span>
</p>
<p>
  <span style="color: rgb(20, 21, 26);">
    6、如何联系我们
  </span>
</p>
<p>
  <br>
</p>
<p>
  <strong style="color: rgb(20, 21, 26);">
    一、个人隐私信息的定义及保证
  </strong>
</p>
<p>
  <span style="color: rgb(20, 21, 26);">
    1、个人隐私信息：是指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息。包括但不限于您在注册或使用平台时填写或生成的
  </span>
  <strong style="color: rgb(20, 21, 26);">
    <u>
      姓名、住址、联系方式、支付信息、交易信息、面部生物识别信息
    </u>
  </strong>
  <span style="color: rgb(20, 21, 26);">
    等单独或与其他信息对照可以识别特定个人的信息。
  </span>
</p>
<p>
  <br>
</p>
<p>
  <span style="color: rgb(20, 21, 26);">
    2、系统权限：是指您在使用平台部分功能时授权平台可调用的系统权限，包括但不限于：
  </span>
  <strong style="color: rgb(20, 21, 26);">
    <u>
      系统相册（如照片存储在外置存储设备，则会调用外置存储设备中的照片信息）、摄像头、地理位置、麦克风
    </u>
  </strong>
  <span style="color: rgb(20, 21, 26);">
    该等系统权限的调用将事先获得您的同意，您也可在系统权限中进行关闭。
  </span>
</p>
<p>
  <strong style="color: rgb(20, 21, 26);">
    <u>
      3、您承诺并保证：您主动填写或者提供给平台的个人信息是真实的、准确的、完整的。而且，填写或者提供给平台后，如果发生了变更的，您会在第一时间内，通过原有的渠道或者平台提供的新的渠道进行更新，以确保平台所获得的您的这些个人信息是最新的、真实的、准确的和完整的；否则，平台无须承担由此给您造成的任何损失。
    </u>
  </strong>
</p>
<p>
  <strong style="color: rgb(20, 21, 26);">
    &nbsp;
  </strong>
</p>
<p>
  <strong style="color: rgb(20, 21, 26);">
    二、我们如何收集和使用您的个人信息
  </strong>
</p>
<p>
  <strong style="color: rgb(20, 21, 26);">
    （一）注册及使用
  </strong>
</p>
<p>
  <span style="color: rgb(20, 21, 26);">
    如您注册包小鉴App/字节跳动小程序/包小鉴H5账户时，我们将收集您的
  </span>
  <strong style="color: rgb(20, 21, 26);">
    <u>
      手机号码
    </u>
  </strong>
  <span style="color: rgb(20, 21, 26);">
    进行实名校验，收集您的
  </span>
  <strong style="color: rgb(20, 21, 26);">
    <u>
      注册昵称及头像
    </u>
  </strong>
  <span style="color: rgb(20, 21, 26);">
    用于公开展示以保证交易辨识度，如您需要上传头像，则上传需要调用
  </span>
  <strong style="color: rgb(20, 21, 26);">
    <u>
      相册及/或摄像头
    </u>
  </strong>
  <span style="color: rgb(20, 21, 26);">
    权限。如您使用第三方应用授权登陆，则我们将收集您的
  </span>
  <strong style="color: rgb(20, 21, 26);">
    <u>
      第三方账户信息，
    </u>
  </strong>
  <span style="color: rgb(20, 21, 26);">
    并与您的包小鉴App/字节跳动小程序/包小鉴H5账户进行绑定，使您可通过第三方账号直接登录、使用我们的产品及/或服务，我们将在您的授权同意的范围内使用您的相关信息。
  </span>
</p>
<p>
  <strong style="color: rgb(51, 51, 51);">
    <u>
      如果您需要注册为个人卖家，首先您需确保已满18周岁。
    </u>
  </strong>
  <span style="color: rgb(51, 51, 51);">
    在满足上述年龄限制的前提下，除了上述收集的信息外，我们还会收集您的
  </span>
  <strong style="color: rgb(51, 51, 51);">
    <u>
      实名身份信息（身份信息、姓名、手机号、地址、面部生物识别信息
    </u>
  </strong>
  <span style="color: rgb(51, 51, 51);">
    用于校验您的卖家身份，同时我们将收集您所填写的用于收款的
  </span>
  <strong style="color: rgb(51, 51, 51);">
    <u>
      银行卡信息或第三方支付信息
    </u>
  </strong>
  <span style="color: rgb(51, 51, 51);">
    用于您的货款结算。
  </span>
</p>
<p>
  <span style="color: rgb(20, 21, 26);">
    您也可在非登陆注册状态下使用包小鉴App/字节跳动小程序/包小鉴H5，我们会收集您的IMEI、IMSI、设备类型、系统版本、IP地址等设备信息。如果您不提供上述信息，可能无法使用包小鉴App/字节跳动小程序/包小鉴H5的服务。
  </span>
  <strong style="color: rgb(20, 21, 26);">
    <u>
      但请注意：单独的设备信息无法识别特定自然人的个人信息。
    </u>
  </strong>
</p>
<p>
  <span style="color: rgb(51, 51, 51);">
    &nbsp;
  </span>
</p>
<p>
  <strong style="color: rgb(20, 21, 26);">
    （二）交易
  </strong>
</p>
<p>
  <span style="color: rgb(20, 21, 26);">
    1、当您在包小鉴App/字节跳动小程序/包小鉴H5购买商品时：
  </span>
</p>
<p>
  <span style="color: rgb(20, 21, 26);">
    （1）我们需要收集您的
  </span>
  <strong style="color: rgb(20, 21, 26);">
    <u>
      收货姓名、联系方式及收货地址
    </u>
  </strong>
  <span style="color: rgb(20, 21, 26);">
    ，用于快递发货以及联系您收货；
  </span>
</p>
<p>
  <span style="color: rgb(20, 21, 26);">
    （2）我们需要收集您的
  </span>
  <strong style="color: rgb(20, 21, 26);">
    <u>
      银行卡信息及第三方支付信息
    </u>
  </strong>
  <span style="color: rgb(20, 21, 26);">
    ,用于您在购买商品时进行支付以及完成风控验证；
  </span>
</p>
<p>
  <span style="color: rgb(20, 21, 26);">
    （3）当您在绑定您的银行卡时，我们需要收集您的
  </span>
  <strong style="color: rgb(20, 21, 26);">
    <u>
      姓名、身份证号码、银行卡卡号、银行预留手机号码
    </u>
  </strong>
  <u style="color: rgb(20, 21, 26);">
    ，
  </u>
  <span style="color: rgb(20, 21, 26);">
    给到第三方支付机构进行银行卡鉴权，确保是您本人持卡消费。如您绑定信用卡，我们还将收集您的
  </span>
  <strong style="color: rgb(20, 21, 26);">
    <u>
      卡片有效期、安全码
    </u>
  </strong>
  <span style="color: rgb(20, 21, 26);">
    用于信用卡鉴权，确保是您本人持卡消费。其中，
  </span>
  <strong style="color: rgb(20, 21, 26);">
    <u>
      有效期、安全码
    </u>
  </strong>
  <span style="color: rgb(20, 21, 26);">
    为第三方支付机构收集后给到发卡银行进行身份校验，包小鉴App/字节跳动小程序/包小鉴H5不会进行存储。您的
  </span>
  <strong style="color: rgb(20, 21, 26);">
    <u>
      姓名、身份证号码、银行卡卡号、银行预留手机号码
    </u>
  </strong>
  <span style="color: rgb(20, 21, 26);">
    将被收集并存储用于识别交易风险，保障您的资金安全。
  </span>
</p>
<p>
  <span style="color: rgb(20, 21, 26);">
    （4）&nbsp;&nbsp;&nbsp;当您产生退款或者赔偿业务时，我们需要收集您的
  </span>
  <strong style="color: rgb(20, 21, 26);">
    <u>
      银行卡信息及第三方支付信息以及真实姓名
    </u>
  </strong>
  <u style="color: rgb(20, 21, 26);">
    ，
  </u>
  <span style="color: rgb(20, 21, 26);">
    用于退款及赔偿的转账；
  </span>
</p>
<p>
  <span style="color: rgb(20, 21, 26);">
    （5）&nbsp;&nbsp;&nbsp;
  </span>
  <span style="color: rgb(51, 51, 51);">
    我们需要收集您的
  </span>
  <strong style="color: rgb(51, 51, 51);">
    <u>
      操作日志
    </u>
  </strong>
  <span style="color: rgb(51, 51, 51);">
    ，根据您的使用记录、设备信息、位置信息、收藏信息、订单信息，向您推荐相关商品；
  </span>
</p>
<p>
  <span style="color: rgb(20, 21, 26);">
    （6）&nbsp;&nbsp;&nbsp;
  </span>
  <span style="color: rgb(51, 51, 51);">
    我们在您自愿的前提下收集您对商品的评价，给予他人参考。对于身高、体重、尺码，您可以选填，
  </span>
  <span style="color: rgb(20, 21, 26);">
    如您不提供前述信息，并不影响您使用我们的评价功能。
  </span>
</p>
<p>
  <span style="color: rgb(20, 21, 26);">
    （7）&nbsp;&nbsp;&nbsp;
  </span>
  <span style="color: rgb(51, 51, 51);">
    商品进行图片搜索时，会调用用户的
  </span>
  <strong style="color: rgb(51, 51, 51);">
    <u>
      相册权限、摄像头权限
    </u>
  </strong>
  <u style="color: rgb(51, 51, 51);">
    ，
  </u>
  <span style="color: rgb(51, 51, 51);">
    用于您拍摄商品照片上传后能快速寻找对应商品。
  </span>
</p>
<p>
  <span style="color: rgb(20, 21, 26);">
    （8）&nbsp;&nbsp;&nbsp;
  </span>
  <span style="color: rgb(51, 51, 51);">
    我们会在您扫描鉴别结果信息时，调用您的
  </span>
  <strong style="color: rgb(51, 51, 51);">
    <u>
      摄像头权限
    </u>
  </strong>
  <span style="color: rgb(51, 51, 51);">
    ，用户可扫描二维码获知商品鉴别结果。
  </span>
</p>
<p>
  <br>
</p>
<p>
  <span style="color: rgb(20, 21, 26);">
    2、当您在包小鉴App/字节跳动小程序/包小鉴H5销售商品时：
  </span>
</p>
<p>
  <span style="color: rgb(51, 51, 51);">
    （1）
  </span>
  <span style="color: rgb(20, 21, 26);">
    &nbsp;&nbsp;&nbsp;
  </span>
  <span style="color: rgb(51, 51, 51);">
    我们需要收集您的
  </span>
  <strong style="color: rgb(51, 51, 51);">
    <u>
      姓名、身份证号码、面部生物识别信息、电话、地址、身份信息
    </u>
  </strong>
  <u style="color: rgb(51, 51, 51);">
    ，
  </u>
  <span style="color: rgb(51, 51, 51);">
    用于按照相关法律确认卖家身份及完成风控验证；
  </span>
</p>
<p>
  <span style="color: rgb(51, 51, 51);">
    （2）
  </span>
  <span style="color: rgb(20, 21, 26);">
    &nbsp;&nbsp;&nbsp;
  </span>
  <span style="color: rgb(51, 51, 51);">
    我们需要收集您的
  </span>
  <strong style="color: rgb(51, 51, 51);">
    <u>
      支付信息，
    </u>
  </strong>
  <span style="color: rgb(51, 51, 51);">
    用于您接收买家支付的货款以及完成风控验证；
  </span>
</p>
<p>
  <span style="color: rgb(51, 51, 51);">
    （3）
  </span>
  <span style="color: rgb(20, 21, 26);">
    &nbsp;&nbsp;&nbsp;
  </span>
  <span style="color: rgb(51, 51, 51);">
    我们需要收集您的
  </span>
  <strong style="color: rgb(51, 51, 51);">
    <u>
      收货姓名、联系方式以及收货地址
    </u>
  </strong>
  <span style="color: rgb(51, 51, 51);">
    ，以便您接受买家或平台退货；
  </span>
</p>
<p>
  <span style="color: rgb(51, 51, 51);">
    （4）
  </span>
  <span style="color: rgb(20, 21, 26);">
    &nbsp;&nbsp;&nbsp;
  </span>
  <span style="color: rgb(51, 51, 51);">
    当您产生退款、赔偿、提现业务时，我们需要收集您的
  </span>
  <strong style="color: rgb(51, 51, 51);">
    <u>
      支付信息以及真实姓名
    </u>
  </strong>
  <span style="color: rgb(51, 51, 51);">
    ，用于退款或赔偿转账；
  </span>
</p>
<p>
  <span style="color: rgb(51, 51, 51);">
    （5）
  </span>
  <span style="color: rgb(20, 21, 26);">
    &nbsp;&nbsp;&nbsp;
  </span>
  <span style="color: rgb(51, 51, 51);">
    我们需要申请您的
  </span>
  <strong style="color: rgb(51, 51, 51);">
    <u>
      相册权限（如照片存储在外置SD卡中，则需要调取SD卡中照片信息）或摄像头权限
    </u>
  </strong>
  <span style="color: rgb(51, 51, 51);">
    ，用于您在添加出售商品时，补充商品照片。
  </span>
</p>
<p>
  <span style="color: rgb(51, 51, 51);">
    （6）
  </span>
  <span style="color: rgb(20, 21, 26);">
    &nbsp;&nbsp;&nbsp;
  </span>
  <span style="color: rgb(51, 51, 51);">
    我们需要申请您的
  </span>
  <strong style="color: rgb(51, 51, 51);">
    <u>
      摄像头权限
    </u>
  </strong>
  <span style="color: rgb(51, 51, 51);">
    ，扫描您的发货运单号，便于您的商品发货。
  </span>
</p>
<p>
  <span style="color: rgb(51, 51, 51);">
    （7）
  </span>
  <span style="color: rgb(20, 21, 26);">
    &nbsp;&nbsp;&nbsp;您在购物过程中可能需要与客服沟通，我们可能会
  </span>
  <strong style="color: rgb(20, 21, 26);">
    <u>
      调用您的摄像头权限
    </u>
  </strong>
  <span style="color: rgb(20, 21, 26);">
    用于您上传照片或视频。同时为便于与您联系、帮助您解决问题，我们可能会保存您与我们的
  </span>
  <strong style="color: rgb(20, 21, 26);">
    <u>
      相关聊天内容（包括账号信息、订单信息、您为了证明相关事实提供的其他信息或您留下的联系方式信息等）
    </u>
  </strong>
  <span style="color: rgb(20, 21, 26);">
    ，如果您咨询事项与具体订单相关，我们还会使用到您的账号信息和订单信息。
  </span>
</p>
<p>
  <strong style="color: rgb(20, 21, 26);">
    （三）服务功能
  </strong>
</p>
<p>
  <span style="color: rgb(20, 21, 26);">
    1、当您在使用上传商品、AI鉴别等功能时，我们会申请你的
  </span>
  <strong style="color: rgb(20, 21, 26);">
    <u>
      相册权限、摄像头权限
    </u>
  </strong>
  <span style="color: rgb(20, 21, 26);">
    ，征得您的同意开通权限后，获得您的图片内容以实现商品信息录入、鉴别真伪。如您不同意开通上述手机权限，可能无法正常使用包墙功能，但是不影响您使用我们提供的其他服务。
  </span>
</p>
<p>
  <br>
</p>
<p>
  <span style="color: rgb(20, 21, 26);">
    2、在您使用鉴别功能时，我们需要申请开通您的
  </span>
  <strong style="color: rgb(20, 21, 26);">
    <u>
      手机相册权限（如照片存储在外置SD卡中，则需要调取SD卡中照片信息）、摄像头权限
    </u>
  </strong>
  <span style="color: rgb(20, 21, 26);">
    ，用于拍摄并上传需要鉴别的商品的图片；我们需要收集您的
  </span>
  <strong style="color: rgb(20, 21, 26);">
    支付信息
  </strong>
  <span style="color: rgb(20, 21, 26);">
    ,用于您在购买鉴别服务时进行支付以及完成风控验证。
  </span>
</p>
<p>
  <br>
</p>
<p>
  <strong style="color: rgb(20, 21, 26);">
    3、
    <u>
      您在使用服务功能的鉴别服务时发布的公开信息可能涉及您或他人的个人信息或个人隐私信息，如您在分享、评论时选择上传的包括个人信息的图片或视频。您应更为谨慎考虑是否公开该等信息，同时如该等信息中保护未成年人个人信息的，您在发布前征得其监护人同意。
    </u>
  </strong>
</p>
<p>
  <span style="color: rgb(20, 21, 26);">
    &nbsp;
  </span>
</p>
<p>
  <strong style="color: rgb(20, 21, 26);">
    （四）风控、安全管理
  </strong>
</p>
<p>
  <span style="color: rgb(20, 21, 26);">
    在您使用我们服务过程中，为识别账号异常状态、了解产品适配性、向您提供更契合您需求的页面展示和搜索结果，我们可能会自动收集您的使用情况并存储为网络日志信息，包括：
  </span>
</p>
<p>
  <br>
</p>
<p>
  <span style="color: rgb(20, 21, 26);">
    1、设备信息：我们会根据您在软件安装及/或使用中的具体操作，接收并记录您所使用的设备硬件信息（包括设备型号、操作系统版本、设备设置、唯一设备标识符、设备环境等软硬件特征信息等）、系统参数、设备所在位置相关信息（包括您授权的GPS位置以及WLAN接入点、蓝牙和基站等传感器信息）、系统软件列表设备唯一标识码等设备信息。
  </span>
</p>
<p>
  <br>
</p>
<p>
  <span style="color: rgb(20, 21, 26);">
    2、服务日志信息：当您使用包小鉴App/字节跳动小程序/包小鉴H5提供的产品或服务时，我们会自动收集您对我们服务的详细使用情况，作为服务日志保存，包括浏览、点击查看、搜索查询、收藏、交易、售后、关注分享信息、发布信息，以及IP地址、访问日期和时间等行为信息。
  </span>
</p>
<p>
  <br>
</p>
<p>
  <strong style="color: rgb(20, 21, 26);">
    <u>
      您应了解：单独的设备信息、服务日志信息是无法识别特定自然人身份的信息。
    </u>
  </strong>
  <span style="color: rgb(20, 21, 26);">
    如果我们将这类非个人信息与其他信息结合用于识别特定自然人身份，或者将其与个人信息结合使用，则在结合使用期间，这类非个人信息将被视为个人信息，除取得您授权或法律法规另有规定外，我们会将这类信息做匿名化、去标识化处理。
  </span>
</p>
<p>
  <br>
</p>
<p>
  <span style="color: rgb(20, 21, 26);">
    另外，根据相关法律法规及国家标准，以下情形中，我们可能会收集、使用您的相关个人信息无需征求您的授权同意：
  </span>
</p>
<p>
  <span style="color: rgb(20, 21, 26);">
    （1)与国家安全、国防安全等国家利益直接相关的；
  </span>
</p>
<p>
  <span style="color: rgb(20, 21, 26);">
    （2)与公共安全、公共卫生、公共知情等重大公共利益直接相关的；
  </span>
</p>
<p>
  <span style="color: rgb(20, 21, 26);">
    （3)与犯罪侦查、起诉、审判和判决执行等直接相关的；
  </span>
</p>
<p>
  <span style="color: rgb(20, 21, 26);">
    （4)出于维护您或其他个人的生命、财产、声誉等重大合法权益但又很难得到本人同意的；
  </span>
</p>
<p>
  <span style="color: rgb(20, 21, 26);">
    （5)所收集的个人信息是您自行向社会公众公开的；
  </span>
</p>
<p>
  <span style="color: rgb(20, 21, 26);">
    （6)从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道；
  </span>
</p>
<p>
  <span style="color: rgb(20, 21, 26);">
    （7)根据您要求签订和履行合同所必需的；
  </span>
</p>
<p>
  <span style="color: rgb(20, 21, 26);">
    （8)用于维护所提供的产品或服务的安全稳定运行所必需的，例如发现、处置产品或服务的故障；
  </span>
</p>
<p>
  <span style="color: rgb(20, 21, 26);">
    （9)法律法规规定的其他情形。
  </span>
</p>
<p>
  <span style="color: rgb(20, 21, 26);">
    &nbsp;
  </span>
</p>
<p>
  <strong style="color: rgb(20, 21, 26);">
    <u>
      如果您选择使用前述说明当中尚未涵盖的其他服务，基于该服务我们需要收集您的信息的，我们会征得您的同意。我们会按照本政策以及相应的用户协议约定使用、存储、对外提供及保护您的信息；如您选择不提供前述信息，您可能无法使用某项或者某部分服务，但是不影响您使用我们提供的其他服务。
    </u>
  </strong>
</p>
<p>
  <span style="color: rgb(20, 21, 26);">
    &nbsp;
  </span>
</p>
<p>
  <strong style="color: rgb(20, 21, 26);">
    三、我们如何管理及保护您的个人信息
  </strong>
</p>
<p>
  <strong style="color: rgb(20, 21, 26);">
    （一）我们如何保护您的个人信息
  </strong>
</p>
<p>
  <span style="color: rgb(20, 21, 26);">
    对于收集的信息，我们努力采取符合业界标准、合理可行的安全防护措施保护您的信息，以防止信息的泄露、丢失、不当使用、未经授权访问、修改和披露等。我们采取多方位的安全保护措施，以确保用户的个人信息保护处于合理的安全水平，包括管理制度控制、安全体系保障等诸多方面。我们会部署访问控制机制，尽力确保只有被授权的人员才可访问个人信息；以及我们会举办安全和隐私保护培训课程，加强员工对于保护个人信息重要性的认识。对于违反义务的人员会根据相关规定进行处罚。
  </span>
</p>
<p>
</p>
<p>
  <span style="color: rgb(20, 21, 26);">
    我们保证我们收集的信息，都是必要的。我们会尽力避免收集无关的个人信息。
  </span>
  <strong style="color: rgb(20, 21, 26);">
    <u>
      我们只会在达成本政策所述目的所需的期限内保留您的个人信息，除非法律有强制的存留要求
    </u>
    ，
  </strong>
  <span style="color: rgb(20, 21, 26);">
    例如《中华人民共和国电子商务法》要求商品和服务信息、交易信息保存时间自交易完成之日起不少于三年。
  </span>
  <strong style="color: rgb(20, 21, 26);">
    <u>
      在您的个人信息超出保留期间后，我们会根据适用法律的要求删除您的个人信息，或使其匿名化处理。
    </u>
  </strong>
</p>
<p>
</p>
<p>
  <strong style="color: rgb(20, 21, 26);">
    <u>
      我们将在中华人民共和国境内运营所收集或产生的个人信息存储在中华人民共和国境内。
    </u>
  </strong>
</p>
<p>
</p>
<p>
  <span style="color: rgb(20, 21, 26);">
    我们建议您在使用产品和服务时充分注意对个人信息的保护，我们也会提供多种安全功能来协助您保护自己的个人信息安全。您应当重视您的个人信息的保护，
  </span>
  <strong style="color: rgb(20, 21, 26);">
    <u>
      您如果发现您的个人信息已经被泄露或者存在被泄露的可能，且有可能会危及您注册获得的包小鉴App/字节跳动小程序/包小鉴H5账户安全，或者给您造成其他的损失的，您务必在第一时间通知平台，以便平台采取相应的措施确保您的包小鉴App/字节跳动小程序/包小鉴H5账户安全，防止损失的发生或者进一步扩大；否则，平台无须承担由此给您造成的任何损失（及扩大的损失）
    </u>
  </strong>
  <span style="color: rgb(20, 21, 26);">
    。
  </span>
</p>
<p>
</p>
<p>
  <span style="color: rgb(20, 21, 26);">
    您充分理解并完全接受：即便是包小鉴App/字节跳动小程序/包小鉴H5采取各种安全技术和程序存储、保护用户信息，防止其被未经授权的访问、使用、复制和泄露，但用户信息仍然有可能发生被黑客攻击、窃取，因不可抗力或者其他非包小鉴App/字节跳动小程序/包小鉴H5的自身原因而被泄露的情形。对此，只要是平台采取了必要的措施防止上述情形之发生，并在上述情形发生之后采取必要的措施防止其损失进一步扩大，平台则无须赔偿由此给您造成的任何损失。
  </span>
</p>
<p>
</p>
<p>
  <span style="color: rgb(51, 51, 51);">
    当我们的服务发生停止运营的情形时，我们会将停止运营的情况以公告的形式向您发送推送。并及时将收集的您的个人信息进行删除。
  </span>
</p>
<p>
  <span style="color: rgb(51, 51, 51);">
    &nbsp;
  </span>
</p>
<p>
  <strong style="color: rgb(51, 51, 51);">
    （二）我们如何管理您的个人信息
  </strong>
</p>
<p>
  <span style="color: rgb(51, 51, 51);">
    为了您可以更加便捷地访问和管理您的信息，您可以通过以下方式进行操作：
  </span>
</p>
<p>
  <span style="color: rgb(51, 51, 51);">
    1、查询、更正、补充您的个人信息
  </span>
</p>
<p>
  <span style="color: rgb(20, 21, 26);">
    （1)账户信息：如果您希望查询并管理您账户中的个人基本资料信息，您可以通过“我的”，然后点击相应位置来更改头像、昵称、性别、密码等。
  </span>
</p>
<p>
  <span style="color: rgb(20, 21, 26);">
    （2)订单信息：您可以在订单页面查看您作为卖家或买家的出售的商品的订单。
  </span>
</p>
<p>
  <span style="color: rgb(20, 21, 26);">
    （3)消息通知：我们会通过平台内的消息通知功能与您取得联系。
  </span>
</p>
<p>
  <span style="color: rgb(20, 21, 26);">
    （4)收款账户：如果您希望管理您的收款账户，可以到“我的”页面点击账户查看
  </span>
</p>
<p>
  <br>
</p>
<p>
  <strong style="color: rgb(20, 21, 26);">
    <u>
      您可以通过您的手机系统设置来管理、开通或关闭系统权限，包括但不限于相册、摄像头、麦克风、地理位置等系统权限。
    </u>
  </strong>
</p>
<p>
  <strong style="color: rgb(51, 51, 51);">
    &nbsp;
  </strong>
</p>
<p>
  <strong style="color: rgb(20, 21, 26);">
    四、&nbsp;我们如何共享、转让、公开披露您的信息
  </strong>
</p>
<p>
  <strong style="color: rgb(20, 21, 26);">
    （一）共享
  </strong>
</p>
<p>
  <span style="color: rgb(20, 21, 26);">
    我们不会向包小鉴App/字节跳动小程序/包小鉴H5服务提供商之外的其他第三方共享您的信息，但您应知悉以下情况下除外：
  </span>
</p>
<p class="ql-align-justify">
  <span style="color: rgb(20, 21, 26);">
    （1）我们可能会根据法律法规规定、诉讼、争议解决需要，或按行政、司法机关依法提出的要求，对外共享您的个人信息。
  </span>
</p>
<p class="ql-align-justify">
  <span style="color: rgb(20, 21, 26);">
    （2）在获得您明确授权同意的情况下，将您的信息共享给第三方。例如您在使用保养业务时，您的必要信息（账户信息）将在您的授权下提供给相应的保养服务提供商；
  </span>
</p>
<p>
  <span style="color: rgb(20, 21, 26);">
    （3）您通过包小鉴App/字节跳动小程序/包小鉴H5购物或使用包小鉴App/字节跳动小程序/包小鉴H5服务时，我们会将您的购物订单或服务中所涉及交易或服务的必要信息共享给您的交易或服务相对方，便于对方为您提供商品或服务。包括但不限于：快递物流服务提供商
  </span>
  <u style="color: rgb(20, 21, 26);">
    （
  </u>
  <strong style="color: rgb(20, 21, 26);">
    <u>
      为派送服务所必须的订单信息、收货人姓名、联系方式、地址信息等
    </u>
  </strong>
  <u style="color: rgb(20, 21, 26);">
    ）
  </u>
  <span style="color: rgb(20, 21, 26);">
    、商品鉴别服务提供商
  </span>
  <u style="color: rgb(20, 21, 26);">
    （
  </u>
  <strong style="color: rgb(20, 21, 26);">
    <u>
      为鉴别服务所必须的订单信息、商品信息
    </u>
  </strong>
  <u style="color: rgb(20, 21, 26);">
    ）
  </u>
  <span style="color: rgb(20, 21, 26);">
    、金融服务提供商
  </span>
  <u style="color: rgb(20, 21, 26);">
    （
  </u>
  <strong style="color: rgb(20, 21, 26);">
    <u>
      为申请授信、使用授信所必须的姓名、身份证号码、银行卡号码及预留手机号码、订单信息等，为金融风控所必须的设备信息等
    </u>
  </strong>
  <u style="color: rgb(20, 21, 26);">
    ）、
  </u>
  <span style="color: rgb(20, 21, 26);">
    第三方支付机构
  </span>
  <u style="color: rgb(20, 21, 26);">
    （
  </u>
  <strong style="color: rgb(20, 21, 26);">
    <u>
      为银行卡快捷支付所必须的姓名、身份证号码、银行卡卡号、预留手机号码、有效期、安全码，其中有效期、安全码仅收集并提供给第三方支付机构进行银行卡鉴权，不进行任何形式的存储
    </u>
  </strong>
  <u style="color: rgb(20, 21, 26);">
    ）
  </u>
  <span style="color: rgb(20, 21, 26);">
    。
  </span>
</p>
<p>
  <span style="color: rgb(20, 21, 26);">
    （4）为便于包小鉴App/字节跳动小程序/包小鉴H5向您提供更优质的服务、识别用户账号的安全性、保护包小鉴App/字节跳动小程序/包小鉴H5或其他第三方的利益不受侵害，您的个人信息可能会与我们的服务提供商共享。但我们将会对信息进行去标识化处理或要求我们的服务商提供更为严格的数据保护措施。包括：我们将会将您拍摄的鞋款图片信息共享给阿里云，通过图片分析获得您图片所对应的商品信息并给您反馈，过程中仅涉及商品照片数据传输；我们将在使用第三方提供的算法推荐服务的情况下向第三方共享行为日志信息，所涉信息均做脱敏处理等；我们在进行内容安全审核时会向第三内容安全服务提供商同步您所发布的内容信息及必要的个人信息（
  </span>
  <strong style="color: rgb(20, 21, 26);">
    头像、昵称等
  </strong>
  <span style="color: rgb(20, 21, 26);">
    ）以判断内容是否合法合规，但我们会要求第三方设立严格的数据保护措施；我们在对您的操作进行账户、交易等风险识别时，可能会将您的设备信息及个人信息（
  </span>
  <strong style="color: rgb(20, 21, 26);">
    手机号码
  </strong>
  <span style="color: rgb(20, 21, 26);">
    ）同步给第三方安全服务提供商以判断你的操作风险，但我们会要求第三方设立严格的数据保护措施。
  </span>
</p>
<p>
  <span style="color: rgb(20, 21, 26);">
    &nbsp;
  </span>
</p>
<p>
  <strong style="color: rgb(20, 21, 26);">
    （二）转让
  </strong>
</p>
<p>
  <span style="color: rgb(20, 21, 26);">
    除非包小鉴App/字节跳动小程序/包小鉴H5运营主体发生变更，否则包小鉴App/字节跳动小程序/包小鉴H5不会向任何第三方转让您的个人信息。如包小鉴App/字节跳动小程序/包小鉴H5运营主体变更导致转让您的个人信息，我们也会严格要求受让主体按照本隐私权政策严格保护您的个人信息。否则，我们将要求该受让主体重新向您征求授权同意。
  </span>
</p>
<p>
  <span style="color: rgb(20, 21, 26);">
    &nbsp;
  </span>
</p>
<p>
  <strong style="color: rgb(20, 21, 26);">
    （三）公开披露
  </strong>
</p>
<p>
  <span style="color: rgb(20, 21, 26);">
    1、我们不会主动地将您的信息向第三方进行披露，但是在以下情形中，我们可能会披露您的个人信息无需事先征得您的授权同意：
  </span>
</p>
<p>
  <span style="color: rgb(20, 21, 26);">
    （1）与国家安全、国防安全直接相关的；
  </span>
</p>
<p>
  <span style="color: rgb(20, 21, 26);">
    （2）与公共安全、公共卫生、重大公共利益直接相关的；
  </span>
</p>
<p>
  <span style="color: rgb(20, 21, 26);">
    （3）与犯罪侦查、起诉、审判和判决执行等直接相关的；
  </span>
</p>
<p>
  <span style="color: rgb(20, 21, 26);">
    （4）出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；
  </span>
</p>
<p>
  <span style="color: rgb(20, 21, 26);">
    （5）个人信息主体自行向社会公众公开个人信息的；
  </span>
</p>
<p>
  <span style="color: rgb(20, 21, 26);">
    （6）从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道。
  </span>
</p>
<p>
  <br>
</p>
<p>
  <span style="color: rgb(20, 21, 26);">
    2、根据相关法律规定，当您被投诉时，我们可能会根据有关行政监管部门的要求，向有关行政监管部门披露您的有关信息，便于投诉纠纷得到有效的解决。
  </span>
</p>
<p>
  <span style="color: rgb(20, 21, 26);">
    &nbsp;
  </span>
</p>
<p>
  <strong style="color: rgb(20, 21, 26);">
    五、我们如何处理未成年人个人信息
  </strong>
</p>
<p>
  <span style="color: rgb(51, 51, 51);">
    我们非常重视未成年人的个人信息保护。在电商活动中，我们推定您具有相应的民事行为能力。如您为未成年人，
  </span>
  <strong style="color: rgb(51, 51, 51);">
    <u>
      请您确保您的父母或监护人已仔细阅读本隐私权政策，并就您使用包小鉴App/字节跳动小程序/包小鉴H5获得您的父母或监护人的同意。
    </u>
  </strong>
</p>
<p>
  <br>
</p>
<p>
  <strong style="color: rgb(51, 51, 51);">
    <u>
      我们不收集任何14周岁以下的未成年人个人信息，如果我们识别出您是未成年人，我们将通过联系您的监护人确认您使用包小鉴App/字节跳动小程序/包小鉴H5是否获得监护人的同意。如发现在未事先获得可证实的父母或其他监护人同意的情况下收集到未成年人个人信息，我们会立刻删除相关信息。
    </u>
  </strong>
</p>
<p>
  <br>
</p>
<p>
  <span style="color: rgb(51, 51, 51);">
    如果您的监护人不同意您按照本政策使用我们的服务或者向我们提供信息，请您立即停止向我们提供信息并及时通知我们，以便于我们将您已经提供的信息进行删除。
  </span>
</p>
<p>
  <span style="color: rgb(51, 51, 51);">
    如果您作为监护人，请您关注您监护的未成年人是否在未取得您的同意的前提下使用包小鉴App/字节跳动小程序/包小鉴H5服务。
  </span>
</p>
<p>
  <br>
</p>
<p>
  <strong style="color: rgb(20, 21, 26);">
    六、如何联系我们
  </strong>
</p>
<p>
  <span style="color: rgb(20, 21, 26);">
    您可以联系包小鉴App/字节跳动小程序/包小鉴H5客服，我们将在5个工作日内回复您的请求，联系方式：service@turingsenseai.com。
  </span>
</p>
<p>
  <span style="color: rgb(20, 21, 26);">
    &nbsp;
  </span>
</p>
<p>
  <span style="color: rgb(20, 21, 26);">
    更新时间：2020年6月15日
  </span>
</p>
<p class="ql-align-center">
  <br>
</p>
`
export default {
  content,
  title: '包小鉴隐私权限'
}
